export enum FinanceSearchField {
    groupName = 'groupName',
    organizationName = 'organizationName',
    processNumber = 'processNumber',
    relationNumber = 'relationNumber',
    requesterPractitionerUid = 'requesterPractitionerUid',
}
